/* esm.sh - react-kapsule@2.5.7 */
export * from "/*react-kapsule@2.5.7/esnext/react-kapsule.mjs";
export { default } from "/*react-kapsule@2.5.7/esnext/react-kapsule.mjs";
